import React, {useState} from 'react'
import {Button} from './Button'
import {CheckIcon} from './icons'
import {signupPageHref, teamPlansUrl} from './constants'

const plans = [
  {
    name: 'Basic',
    price: '$0',
    unit: 'forever',
    desc: 'Discover what Listing Management can do for you.',
    cta: 'Start free',
    ctaVariant: 'outline',
    href: signupPageHref,
    featured: false,
    bullets: [
      'Unlimited listings and disclosure packages',
      'Broadcast listing updates to every viewer',
      'Offer inbox and dashboard comparison',
      'TC and assistant access',
      'DocuSign integration',
    ],
  },
  {
    name: 'Pro',
    price: '$39',
    unit: 'per agent / month',
    desc: 'For full-time listing agents who want every edge.',
    cta: 'Try Pro free for 14 days',
    ctaVariant: 'primary',
    href: signupPageHref,
    featured: true,
    bullets: [
      {text: 'Everything in Basic', emphasis: true},
      'Buyer activity tracking & engagement scoring',
      'Offer intelligence with net proceeds estimates',
      'AI summary of disclosures, cited to the page',
      'One-to-one messaging with full thread history',
      'Seller access as a listing party',
      'Custom branding and templates',
    ],
  },
  {
    name: 'Team',
    price: 'Custom',
    unit: '',
    desc: 'For teams and brokerages that want one system.',
    cta: 'Contact us',
    ctaVariant: 'outline',
    href: teamPlansUrl,
    external: true,
    featured: false,
    bullets: [
      {text: 'Everything in Pro', emphasis: true},
      'Volume pricing for your agents',
      'Dedicated onboarding and training',
      '1-on-1 support',
    ],
  },
]

function PricingV2() {
  const [annual, setAnnual] = useState(false)

  return (
    <section id="pricing" className="hlm-pricing">
      <div className="hlm-container">
        <div className="hlm-section-intro">
          <h2>Start free. Go Pro to win more.</h2>
          <p className="hlm-section-lede">No contracts and no per-listing fees.</p>
        </div>

        <div className="hlm-billing" role="radiogroup" aria-label="Billing period">
          <label className={!annual ? 'is-on' : ''}>
            <input type="radio" name="hlm-billing" value="monthly" checked={!annual} onChange={() => setAnnual(false)} />
            Monthly
          </label>
          <label className={annual ? 'is-on' : ''}>
            <input type="radio" name="hlm-billing" value="annual" checked={annual} onChange={() => setAnnual(true)} />
            Annual
            <span className="hlm-billing-save">Save 15%</span>
          </label>
        </div>

        <div className="hlm-pricing-row">
          {plans.map(plan => {
            const price = plan.name === 'Pro' && annual ? '$399' : plan.price
            const unit = plan.name === 'Pro' && annual ? 'per agent / year' : plan.unit
            return (
              <div className={`hlm-plan${plan.featured ? ' is-pro' : ''}`} key={plan.name}>
              <div className="hlm-plan-top">
                <span className="hlm-plan-name">{plan.name}</span>
                {plan.featured ? <span className="hlm-plan-badge">Most popular</span> : null}
              </div>
              <div className="hlm-plan-price">
                <strong>{price}</strong>
                {unit ? <span>{unit}</span> : null}
              </div>
              <p className="hlm-plan-desc">{plan.desc}</p>
              <Button
                href={plan.href}
                variant={plan.ctaVariant}
                size="md"
                target={plan.external ? '_blank' : undefined}
                rel={plan.external ? 'noopener noreferrer' : undefined}>
                {plan.cta}
              </Button>
              <div className="hlm-plan-list">
                {plan.bullets.map(bullet => {
                  const text = typeof bullet === 'string' ? bullet : bullet.text
                  const emphasis = typeof bullet === 'object' && bullet.emphasis
                  return (
                    <div className={`hlm-plan-item${emphasis ? ' is-emphasis' : ''}`} key={text}>
                      <CheckIcon size={18} stroke={2.5} />
                      {text}
                    </div>
                  )
                })}
              </div>
            </div>
            )
          })}
        </div>
        <p className="hlm-pricing-note">Switch or cancel anytime. Your listings and history stay with you.</p>
      </div>
    </section>
  )
}

export default PricingV2
